var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.activeContent === "select-duration"
        ? _c(
            "b-row",
            {
              staticStyle: { "margin-bottom": "40px", "text-align": "center" },
              attrs: { "align-h": "center" }
            },
            [
              _c("b-col", { attrs: { cols: "12", md: "4" } }, [
                _c("div", { staticClass: "duration-container" }, [
                  _c("h4", { staticClass: "font-weight-bold mb-4" }, [
                    _vm._v("Select Duration")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column align-items-start" },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column duration-item" },
                        [
                          _c(
                            "div",
                            { staticClass: "small-muted-text text-left" },
                            [_vm._v("Recurring")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-start" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "input-radio d-flex align-items-start"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.recurring,
                                        expression: "recurring"
                                      }
                                    ],
                                    attrs: { type: "radio", name: "recurring" },
                                    domProps: {
                                      value: true,
                                      checked: _vm._q(_vm.recurring, true)
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.recurring = true
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "d-flex flex-column" }, [
                                _c("span", { staticClass: "duration-text" }, [
                                  _vm._v("Monthly Subscription")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "duration-images d-flex align-items-start"
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/visa.png"),
                                        alt: "logo"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/master.png"),
                                        alt: "logo"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/american-express.png"),
                                        alt: "logo"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.canApplePay
                                      ? _c("img", {
                                          attrs: {
                                            src: require("@/assets/apple-pay.png"),
                                            alt: "logo"
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                )
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "line-separator" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column duration-item" },
                        [
                          _c(
                            "div",
                            { staticClass: "small-muted-text text-left" },
                            [_vm._v("ONE-TIME PAYMENT")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-start" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "input-radio d-flex align-items-start"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.recurring,
                                        expression: "recurring"
                                      }
                                    ],
                                    attrs: { type: "radio", name: "recurring" },
                                    domProps: {
                                      value: false,
                                      checked: _vm._q(_vm.recurring, false)
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.recurring = false
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                [
                                  _c("b-form-select", {
                                    staticStyle: { "margin-bottom": "9px" },
                                    attrs: { options: _vm.listMonth },
                                    model: {
                                      value: _vm.oneTimeMonth,
                                      callback: function($$v) {
                                        _vm.oneTimeMonth = $$v
                                      },
                                      expression: "oneTimeMonth"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "duration-images d-flex align-items-start"
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/visa.png"),
                                          alt: "logo"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/master.png"),
                                          alt: "logo"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/american-express.png"),
                                          alt: "logo"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.getUser.data.country.code === "PH"
                                        ? _c("img", {
                                            attrs: {
                                              src: require("@/assets/grabpay.png"),
                                              alt: "logo"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.getUser.data.country.code === "PH"
                                        ? _c("img", {
                                            attrs: {
                                              src: require("@/assets/gcash.png"),
                                              alt: "logo"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/wechat.png"),
                                          alt: "logo"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.canApplePay
                                        ? _c("img", {
                                            attrs: {
                                              src: require("@/assets/apple-pay.png"),
                                              alt: "logo"
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-block mb-3 mt-5",
                      on: { click: _vm.submitDuration }
                    },
                    [_vm._v("Select Amount")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "text-center d-flex flex-column align-items-start"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-top": "5px",
                            "margin-bottom": "-3px"
                          }
                        },
                        [_vm._v("*All prices exclusive of service fee")]
                      )
                    ]
                  )
                ])
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activeContent === "select-amount"
        ? _c(
            "b-row",
            {
              staticStyle: { "margin-bottom": "40px", "text-align": "center" },
              attrs: { "align-h": "center" }
            },
            [
              _c("b-col", { attrs: { cols: "12", md: "5" } }, [
                _c("h4", { staticClass: "font-weight-bold mb-4" }, [
                  _vm._v("Select Amount")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "fire mb-2" }, [
                  _vm._v("🔥 Limited time. Pay what you can afford")
                ]),
                _vm._v(" "),
                _c("h5", { staticClass: "mb-4" }, [
                  _vm._v(_vm._s(_vm.membershipText))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "range-container" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column align-items-center mb-3"
                      },
                      [
                        _c("span", { staticClass: "price-approx" }, [
                          _vm._v(_vm._s(_vm.approxText))
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "price-text mb-1",
                            class:
                              _vm.inputType === "slider" ? _vm.textRule : ""
                          },
                          [
                            _vm._v(
                              "$" +
                                _vm._s(
                                  _vm.inputType === "slider"
                                    ? _vm.rangeVal
                                    : _vm.inputPrice
                                )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.recurring === true
                          ? _c("span", { staticClass: "price-per-month" }, [
                              _vm._v("/month")
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _vm.inputType === "slider"
                      ? _c(
                          "div",
                          { staticClass: "d-inline-block w-100 mb-5 px-3" },
                          [
                            _vm.activeContent === "select-amount"
                              ? _c("vue-slider", {
                                  attrs: {
                                    tooltip: "none",
                                    min: _vm.min,
                                    max: _vm.max,
                                    "dot-size": 32,
                                    "dot-style": { background: "#224181" },
                                    "rail-style": {
                                      backgroundColor: "#AAAAAA"
                                    },
                                    contained: true,
                                    marks: _vm.marks
                                  },
                                  on: { change: _vm.selectPrice },
                                  scopedSlots: _vm._u(
                                    [
                                      _vm.recurring === true
                                        ? {
                                            key: "mark",
                                            fn: function(ref) {
                                              var pos = ref.pos
                                              var label = ref.label
                                              return [
                                                label === _vm.lowestPrice
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "custom-mark-start"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                $" +
                                                            _vm._s(label) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    )
                                                  : label === _vm.defaultPrice
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "custom-mark",
                                                        style: {
                                                          left: pos + "%"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "arrow",
                                                            attrs: {
                                                              icon: [
                                                                "fas",
                                                                "caret-up"
                                                              ],
                                                              size: "3x"
                                                            }
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "recommend-text"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Recommended Price"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : label === _vm.max
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "custom-mark-end"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                $" +
                                                            _vm._s(label) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        : !_vm.recurring
                                        ? {
                                            key: "mark",
                                            fn: function(ref) {
                                              var pos = ref.pos
                                              var label = ref.label
                                              return [
                                                label === _vm.lowestPrice
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "custom-mark-start"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                $" +
                                                            _vm._s(label) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                label === _vm.defaultPrice
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "custom-mark",
                                                        style: {
                                                          left: pos + "%"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "arrow",
                                                            attrs: {
                                                              icon: [
                                                                "fas",
                                                                "caret-up"
                                                              ],
                                                              size: "3x"
                                                            }
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "recommend-text"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Recommended Price"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : label === _vm.max
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "custom-mark-end"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                $" +
                                                            _vm._s(label) +
                                                            "\n              "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        : null
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.rangeVal,
                                    callback: function($$v) {
                                      _vm.rangeVal = $$v
                                    },
                                    expression: "rangeVal"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.inputType === "slider"
                      ? _c(
                          "div",
                          {
                            staticClass: "info-text d-inline-block w-90 mt-2",
                            class: _vm.infoTextColor
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.infoTextRule) +
                                "\n        "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.inputType === "input"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-inline-block w-100 mt-5 position-relative",
                            staticStyle: { height: "56px" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inputPrice,
                                  expression: "inputPrice"
                                }
                              ],
                              staticClass: "form-control input-custom-form",
                              attrs: { type: "number", min: "100" },
                              domProps: { value: _vm.inputPrice },
                              on: {
                                keyup: _vm.inputChange,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inputPrice = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "position-absolute ml-2",
                              staticStyle: { top: "10px", left: "10px" },
                              attrs: { src: require("@/assets/dollar.svg") }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.inputType === "input" && !_vm.isValidInputCustom
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex w-100 justify-content-center mt-3"
                          },
                          [
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("Minimum amount is 100")
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-center mt-5" },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "input-custom cursor-pointer",
                            on: { click: _vm.inputCustom }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.inputType === "slider"
                                    ? "Input more than $100 "
                                    : "Back to Default"
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.recurring
                      ? [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-primary btn-block mb-3 mt-5",
                              attrs: {
                                disabled:
                                  _vm.inputType === "input" &&
                                  !_vm.isValidInputCustom
                              },
                              on: { click: _vm.pay }
                            },
                            [_vm._v("Go to payment")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-center d-flex flex-column align-items-center"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-top": "5px",
                                    "margin-bottom": "-3px"
                                  }
                                },
                                [_vm._v("*All prices exclusive of Stripe fees")]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "*1% additional fee will be added for countries outside US"
                                )
                              ])
                            ]
                          )
                        ]
                      : !_vm.recurring
                      ? [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-primary btn-block mb-3 mt-5",
                              attrs: {
                                disabled:
                                  _vm.inputType === "input" &&
                                  !_vm.isValidInputCustom
                              },
                              on: { click: _vm.goToPaymentMethod }
                            },
                            [_vm._v("Go to payment method")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-center d-flex flex-column align-items-center"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-top": "5px",
                                    "margin-bottom": "-3px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "*All prices are exclusive of service fee"
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "w-100" }),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "d-flex justify-content-center",
                  attrs: { cols: "12", md: "4" }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn-back d-flex rounded-circle cursor-pointer",
                      on: { click: _vm.back }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "icon-back",
                        attrs: { icon: ["fas", "chevron-left"] }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activeContent === "select-payment"
        ? _c(
            "b-row",
            {
              staticStyle: { "margin-bottom": "40px", "text-align": "center" },
              attrs: { "align-h": "center" }
            },
            [
              _c("b-col", { attrs: { cols: "12", md: "4" } }, [
                _c("div", { staticClass: "payment-container" }, [
                  _c("h4", { staticClass: "font-weight-bold mb-4" }, [
                    _vm._v("Select Payment")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex flex-column" }, [
                    _c("div", { staticClass: "d-flex flex-column" }, [
                      _c(
                        "span",
                        { staticClass: "small-muted-text text-left" },
                        [_vm._v("CARD")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-column",
                          staticStyle: { "margin-bottom": "68px" }
                        },
                        [
                          _c("div", { staticClass: "d-flex" }, [
                            _c("div", { staticClass: "input-radio-payment" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.paymentMethod,
                                    expression: "paymentMethod"
                                  }
                                ],
                                attrs: {
                                  type: "radio",
                                  name: "payment_method",
                                  value: "credit_card"
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.paymentMethod,
                                    "credit_card"
                                  )
                                },
                                on: {
                                  click: _vm.changePaymentMethod,
                                  change: function($event) {
                                    _vm.paymentMethod = "credit_card"
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "payment-method-label w-100 text-left"
                              },
                              [
                                _vm._v(
                                  "\n                  Credit Card / Debit Card\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "payment-method-images d-flex justify-content-end"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/visa.png"),
                                    alt: "logo"
                                  }
                                }),
                                _vm._v(" "),
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/master.png"),
                                    alt: "logo"
                                  }
                                }),
                                _vm._v(" "),
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/american-express.png"),
                                    alt: "logo"
                                  }
                                }),
                                _vm._v(" "),
                                _vm.canApplePay
                                  ? _c("img", {
                                      attrs: {
                                        src: require("@/assets/apple-pay.png"),
                                        alt: "logo"
                                      }
                                    })
                                  : _vm._e()
                              ]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    !_vm.recurring
                      ? _c("div", { staticClass: "d-flex flex-column" }, [
                          _c(
                            "span",
                            { staticClass: "small-muted-text text-left" },
                            [_vm._v("WALLET")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "d-flex flex-column",
                              staticStyle: { "margin-bottom": "40px" }
                            },
                            [
                              _vm.getUser.data.country.code === "PH"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex payment-item justify-content-between"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-radio-payment" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.paymentMethod,
                                                expression: "paymentMethod"
                                              }
                                            ],
                                            attrs: {
                                              type: "radio",
                                              name: "payment_method",
                                              value: "grab_pay"
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.paymentMethod,
                                                "grab_pay"
                                              )
                                            },
                                            on: {
                                              click: _vm.changePaymentMethod,
                                              change: function($event) {
                                                _vm.paymentMethod = "grab_pay"
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "payment-method-label text-left w-100"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  GrabPay\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "payment-method-images d-flex justify-content-end"
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/grabpay.png"),
                                              alt: "logo"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.getUser.data.country.code === "PH"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex payment-item justify-content-between"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-radio-payment" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.paymentMethod,
                                                expression: "paymentMethod"
                                              }
                                            ],
                                            attrs: {
                                              type: "radio",
                                              name: "payment_method",
                                              value: "gcash"
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.paymentMethod,
                                                "gcash"
                                              )
                                            },
                                            on: {
                                              click: _vm.changePaymentMethod,
                                              change: function($event) {
                                                _vm.paymentMethod = "gcash"
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "payment-method-label text-left w-100"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  GCash\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "payment-method-images d-flex justify-content-end"
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/gcash.png"),
                                              alt: "logo"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex payment-item justify-content-between"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "input-radio-payment" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.paymentMethod,
                                            expression: "paymentMethod"
                                          }
                                        ],
                                        attrs: {
                                          type: "radio",
                                          name: "payment_method",
                                          value: "wechat"
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.paymentMethod,
                                            "wechat"
                                          )
                                        },
                                        on: {
                                          click: _vm.changePaymentMethod,
                                          change: function($event) {
                                            _vm.paymentMethod = "wechat"
                                          }
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "payment-method-label text-left w-100"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  WeChat Pay\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "payment-method-images d-flex justify-content-end"
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/wechat.png"),
                                          alt: "logo"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-block mb-3 mt-5",
                      on: { click: _vm.pay }
                    },
                    [_vm._v("Go to payment")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "text-center d-flex flex-column align-items-start"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-top": "5px",
                            "margin-bottom": "-3px"
                          }
                        },
                        [_vm._v("*All prices exclusive of service fee")]
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "w-100" }),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "d-flex justify-content-center mt-5",
                  attrs: { cols: "12", md: "4" }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn-back d-flex rounded-circle cursor-pointer",
                      on: { click: _vm.backPayment }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "icon-back",
                        attrs: { icon: ["fas", "chevron-left"] }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-abca2100", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abca2100","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Subscribe.vue
// module id = null
// module chunks = 